import axios from 'axios';
import i18next from 'i18next';

const setupLanguageHeader = () => {
  axios.interceptors.request.use(
    (config) => {
      const language = i18next.language || i18next.resolvedLanguage || i18next.languages[0] || 'en';
      config.headers['Accept-Language'] = language;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default setupLanguageHeader;
